import { useRef } from "react";
import CommonConstants from "../constants";

/**
 * LogoWhite
 */

export const LogoWhite = () => {
  const logoRef = useRef(CommonConstants.assets.logoWhite);
  return <img src={logoRef.current} alt="logo gdol" className="w-[100px]" />;
};